import { Colors } from '@blueprintjs/core';
import { css } from "@emotion/react";

export const commonStyle = {
	tightCard: css`
		display: flex;
		align-items: center;
		padding: 0;
		overflow: hidden;
	`
}

export const explorerStyles = {
	container: css`
		flex: 1 1;
		height: 100%;
		display: grid;
		grid-template-columns: 400px 1fr 400px;
		grid-template-rows: auto auto 150px 1fr;
		grid-gap: 6px;
		padding: 8px;
		background-color: ${Colors.LIGHT_GRAY5};
		overflow: hidden;
	`,
	filters: css`
		${commonStyle.tightCard};
		grid-column: 1 / 3;
	`,
	widgets: css`
		${commonStyle.tightCard};
	`,
	timeline: css`
		${commonStyle.tightCard};
		grid-column: 1 / 3;
	`,
	facets: css`
		${commonStyle.tightCard};
	`,
	search: css`
		/* ${commonStyle.tightCard}; */
		/* overflow: unset; */
		grid-column: 1 / 3;
	`,
	list: css`
		${commonStyle.tightCard};
		padding: 0;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		grid-row: 1 / 7; 
		grid-column: 3 / 3; 
	`,
	viewer: css`
			${commonStyle.tightCard}
	`
}
